import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, Grid, Typography } from "@mui/material";
import clsx from "clsx";
import promotionCard from "@/assets/promotionCard.svg";
import promotionFirst from "@/assets/promotionFirst.png";
import promotionSecond from "@/assets/promotionSecond.png";
import { theme } from "@/components/Elements/theme";
import { url } from "inspector";
import HomeScreenImg from "@/assets/earth.jpg";

import Countdown from "react-countdown";
import { useDonationList } from "../api/getDonation";
import Header from "@/components/Elements/header";
import HeaderValue from "@/components/Elements/headerMain";
import Footer from "@/components/Elements/footer";
import { useAuth } from "@/lib/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  paperClass: {
    padding: theme.spacing(2),
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
  },

  myGridItem: {
    backgroundColor: "rgba(5, 5, 24, 0.8)",
    padding: "30px",
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  innerGridFirst: {
    background: `url(${promotionFirst})`,
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    minHeight: "282px",
    minWidth: "282px",
    backgroundPosition: "left bottom",
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  cardRoot: {
    background: "rgba(5, 5, 24, 0.25)",
    boxShadow: "0px 2.81226px 28.1226px 7.03066px rgba(0, 0, 0, 0.03)",
    borderRadius: "10px",
  },
}));

export default function Donation() {
  const classes = useStyles();
  const DataValue = useDonationList({});
  const auth = useAuth();

  return (
    <>
      {auth.user ? <Header /> : <HeaderValue />}
      <Box
        sx={{
          background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          minHeight: "100%",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          padding: {
            xs: "10px 0",
            lg: "100px 0px 20px",
          },
        }}
      >
        <Box
          sx={{
            maxWidth: "95%",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              padding: { lg: "40px ", xs: "20px 10px 30px" },
              backgroundColor: "rgba(5, 5, 24, 0.8)",
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(63, 63, 63, 0.7)",
              minHeight: "calc(100vh - 300px)",
            }}
          >
            <Grid
              container
              display={"flex"}
              direction={"row"}
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ marginBottom: "40px" }}
            >
              <Grid item xs={12} sm={4} md={4.5}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    [theme.breakpoints.down("md")]: { maxWidth: "250px" },
                    [theme.breakpoints.down("sm")]: { maxWidth: "200px" },
                    margin: "0 auto",
                  }}
                >
                  <img
                    src={
                      `${process.env.API_URL_PREFIX}/api/v1/admin/uploads/` +
                      DataValue?.data?.[0]?.image
                    }
                    alt="donation image"
                    style={{ width: "auto", maxWidth: "100%" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={8} md={7.5}>
                <Box
                  sx={{
                    color: "white",
                    textAlign: "start",
                  }}
                >
                  <Typography
                    component={"h1"}
                    sx={{
                      fontSize: { xs: "20px", sm: "22px", md: "24px" },
                      fontWeight: 500,
                      color: "#3C37FF",
                      marginTop: "0px",
                    }}
                  >
                    {DataValue?.data && DataValue?.data?.[0]?.heading}
                  </Typography>
                  <Typography
                    component={"p"}
                    sx={{
                      fontSize: "14px",
                      opacity: "0.7",
                      fontWeight: 400,
                      lineHeight: "150%",
                    }}
                  >
                    {DataValue?.data?.[0]?.description !== undefined && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            DataValue?.data &&
                            DataValue?.data?.[0]?.description,
                        }}
                      />
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
